import { buildConnectivityActions as originalBuildConnectivityActions } from '../../connectivity';
import { mockActionsExpect } from '../helpers';
export const buildConnectivityActions = (store, api, actions) => {
  const originalActions = originalBuildConnectivityActions(store, api, actions);
  const mockedActions = mockActionsExpect(originalActions, ['setConnectivityState', 'resetConnectivityState', 'initData', 'resetConnectivityState', 'cleanWebhookTestData', 'cleanWebhookLogsData', 'cleanWebhookTestMessage', 'cleanError', 'cleanSlackData']);
  return mockedActions;
};